import { useTanstack } from "../../hooks/useTanstack";
import { Meta } from "../../meta/meta";
// import { htmlToText } from "../../utils/formatters";
import { GoBack } from "../../components/ui/goBack";
import { Title } from "../../components/ui/typography/title";
import styles from "./contact.module.scss";

const Contact = () => {
  const { data } = useTanstack("getWebContacts");

  return (
    <>
      <Meta title="contact" description="contact_description" />
      <main className={styles.contact}>
        <div className="container">
          <div className={styles.contact_top}>
            <GoBack />
            <Title text="contact" />
          </div>

          <div
            className={styles.contact_text}
            dangerouslySetInnerHTML={{
              __html: data?.text,
            }}
          />

          {data?.image && (
            <div>
              <img src={data?.image} alt="img" />
            </div>
          )}
        </div>
      </main>
    </>
  );
};

export default Contact;
